import { axiosRequest } from '@/util/axios-request';
var method = 'get';
var orgInfoUrl = '/web/organization/info';
var depListUrl = '/web/organization/departmentList';
var createFnUrl = '/web/organization/createDepartment';
var delFnUrl = '/web/organization/deldepartment';
var editFnUrl = '/web/organization/editDepartment';
var updateStaffDepartmentUrl = '/web/staff/updateStaffDepartment';
var depInfo = '/web/Organization/departmentInfo';
var depList = '/web/organization/departmentAllList';
var sortSave = '/web/organization/savedeptsort';

// 组织信息
export var orgInfoFn = function orgInfoFn() {
  return axiosRequest({
    url: orgInfoUrl,
    method: method
  });
};

// 部门列表
export var depListFn = function depListFn(params) {
  return axiosRequest({
    url: depListUrl,
    method: method,
    params: params
  });
};

// 部门创建
export var createFn = function createFn(data) {
  return axiosRequest({
    url: createFnUrl,
    data: data
  });
};

// 部门删除
export var delFn = function delFn(data) {
  return axiosRequest({
    url: delFnUrl,
    data: data
  });
};

// 部门编辑
export var editFn = function editFn(data) {
  return axiosRequest({
    url: editFnUrl,
    data: data
  });
};

// 员工批量设置部门信息
export var updateStaffDepartmentFn = function updateStaffDepartmentFn(data) {
  return axiosRequest({
    url: updateStaffDepartmentUrl,
    data: data
  });
};

// 部门信息
export var depInfoFn = function depInfoFn(params) {
  return axiosRequest({
    url: depInfo,
    method: method,
    params: params
  });
};

// 部门列表
export var getDepList = function getDepList(params) {
  return axiosRequest({
    url: depList,
    method: method,
    params: params
  });
};

// 部门列表
export var saveDepSort = function saveDepSort(params) {
  return axiosRequest({
    url: sortSave,
    data: params
  });
};